import type { ToolContent } from "./tool-content";
import { getEsPdfToolBySlug } from "./es-pdf-catalog";

interface EsPdfSeoOverride {
  h1Title: string;
  seoTitle: string;
  seoDescription: string;
  intro: string;
  faq?: { q: string; a: string }[];
}

const ES_PDF_SEO_DATA: Record<string, EsPdfSeoOverride> = {
  "unir-pdf": {
    h1Title: "Unir PDF Gratis Online — Combinar Archivos PDF en Uno Solo",
    seoTitle: "Unir PDF Gratis Online — Combinar Archivos PDF | Picamini.online",
    seoDescription: "Unir PDF gratis online sin instalar programas ni subir archivos a servidores externos. Junta varios documentos PDF en un solo archivo de forma 100% privada.",
    intro: "Combina dos o más archivos PDF en un único documento organizado en línea gratis. Reordena hojas, selecciona rangos de páginas y descarga al instante con total privacidad.",
    faq: [
      {
        q: "¿Es seguro unir mis documentos PDF en Picamini.online?",
        a: "Absolutamente. El proceso de unión se realiza de manera 100% local en tu propio navegador web mediante JavaScript. Tus archivos nunca se suben a ningún servidor externo."
      },
      {
        q: "¿Hay límite en la cantidad de archivos PDF que puedo combinar?",
        a: "No hay límites artificiales impuestos por la web. Puedes combinar tantos archivos PDF como la memoria de tu dispositivo lo permita."
      }
    ]
  },
  "dividir-pdf": {
    h1Title: "Dividir PDF Online Gratis — Separar Páginas de PDF",
    seoTitle: "Dividir PDF Online Gratis — Separar Páginas de PDF | Picamini.online",
    seoDescription: "Dividir PDF gratis online — extrae páginas específicas o separa documentos PDF grandes en archivos independientes sin subir nada a servidores.",
    intro: "Separa páginas o extrae rangos personalizados en nuevos documentos PDF individuales de manera sencilla, rápida y totalmente privada.",
  },
  "organizar-pdf": {
    h1Title: "Organizar Páginas de PDF Gratis Online",
    seoTitle: "Organizar Páginas de PDF Gratis Online | Picamini.online",
    seoDescription: "Reordena, gira o elimina hojas de tus archivos PDF mediante arrastrar y soltar visualmente en tu navegador.",
    intro: "Reorganiza el orden de las páginas de tu archivo PDF de forma visual e intuitiva sin subir documentos a internet.",
  },
  "rotar-pdf": {
    h1Title: "Rotar PDF Online Gratis — Girar Páginas de PDF",
    seoTitle: "Rotar PDF Online Gratis — Girar Páginas | Picamini.online",
    seoDescription: "Gira hojas individuales o todas las páginas de tu archivo PDF 90, 180 o 270 grados de forma permanente.",
    intro: "Corrige la orientación de hojas escaneadas al revés o de lado de manera permanente y descarga tu PDF ordenado.",
  },
  "extraer-paginas-pdf": {
    h1Title: "Extraer Páginas de PDF Gratis — Guardar Hojas Seleccionadas",
    seoTitle: "Extraer Páginas de PDF Gratis Online | Picamini.online",
    seoDescription: "Selecciona y extrae hojas concretas de un archivo PDF pesado para crear un nuevo documento ligero.",
    intro: "Elige las páginas exactas que necesitas de un PDF y genera un nuevo documento limpio en segundos.",
  },
  "eliminar-paginas-pdf": {
    h1Title: "Eliminar Páginas de PDF Gratis — Borrar Hojas Unerwünschtes",
    seoTitle: "Eliminar Páginas de PDF Gratis Online | Picamini.online",
    seoDescription: "Quita hojas en blanco, duplicadas o innecesarias de tus documentos PDF directamente en tu navegador.",
    intro: "Borra de forma permanente cualquier página no deseada de tus archivos PDF con un solo clic.",
  },
  "editar-pdf": {
    h1Title: "Editor de PDF Online Gratis — Añadir Texto, Firmas y Dibujos",
    seoTitle: "Editor de PDF Online Gratis — Modificar PDF | Picamini.online",
    seoDescription: "Editor de PDF gratis online. Añade texto, firma documentos, dibuja, inserta imágenes y resalta contenido sin descargar aplicaciones.",
    intro: "Agrega anotaciones, cuadros de texto, firmas escritas o dibujadas a mano e imágenes en tus documentos PDF de manera cómoda e intuitiva.",
  },
  "numerar-paginas-pdf": {
    h1Title: "Numerar Páginas de PDF Gratis — Añadir Números de Página",
    seoTitle: "Numerar Páginas de PDF Gratis Online | Picamini.online",
    seoDescription: "Inserta números de página automáticos en el encabezado o pie de página de tus documentos PDF.",
    intro: "Añade numeración personalizada a tus trabajos, informes y documentos en la posición y formato que prefieras.",
  },
  "marca-de-agua-pdf": {
    h1Title: "Añadir Marca de Agua a PDF Gratis — Texto o Logotipo",
    seoTitle: "Añadir Marca de Agua a PDF Gratis Online | Picamini.online",
    seoDescription: "Inserta marcas de agua de texto o imagen en tus archivos PDF gratis. Personaliza transparencia, posición y ángulo directamente en tu navegador.",
    intro: "Protege tus documentos estampando marcas de agua con texto personalizado o el logotipo de tu empresa sobre las páginas de tu archivo PDF.",
  },
  "comprimir-pdf": {
    h1Title: "Comprimir PDF Gratis Online — Reducir Tamaño sin Perder Calidad",
    seoTitle: "Comprimir PDF Gratis Online — Reducir Tamaño de PDF | Picamini.online",
    seoDescription: "Comprimir PDF online gratis — reduce el peso de tu archivo PDF para enviarlo por correo sin perder nitidez. 100% privado en tu navegador.",
    intro: "Reduce el peso de tus archivos PDF para adjuntarlos fácilmente por correo electrónico o subirlos a plataformas digitales manteniendo una excelente calidad visual.",
  },
  "convertir-pdf-blanco-y-negro": {
    h1Title: "Convertir PDF a Blanco y Negro Gratis — Escala de Grises",
    seoTitle: "Convertir PDF a Blanco y Negro Gratis Online | Picamini.online",
    seoDescription: "Transforma archivos PDF a color en escala de grises para ahorrar tinta y costes de impresión.",
    intro: "Convierte tus PDF a blanco y negro para ahorrar tinta de impresora sin alterar la legibilidad del texto.",
  },
  "reparar-pdf": {
    h1Title: "Reparar PDF Dañado Gratis — Recuperar Archivos PDF",
    seoTitle: "Reparar PDF Dañado Gratis Online | Picamini.online",
    seoDescription: "Recupera datos y contenido de archivos PDF corruptos o dañados directamente en tu navegador.",
    intro: "Repara documentos PDF defectuosos y recupera el texto e imágenes contenidos sin pérdida de datos.",
  },
  "convertir-imagen-a-pdf": {
    h1Title: "Convertir Imagen a PDF Gratis — JPG, PNG y WEBP a PDF",
    seoTitle: "Convertir Imagen a PDF Gratis (JPG a PDF) | Picamini.online",
    seoDescription: "Convertir imágenes JPG, PNG, WEBP y GIF a PDF online gratis. Junta múltiples fotos en un documento PDF bien maquetado sin marcas de agua.",
    intro: "Convierte imágenes JPG, PNG, WEBP o GIF en un archivo PDF ordenado. Ajusta márgenes, orientación de hoja e imprime o guarda directamente en tu ordenador.",
  },
  "convertir-word-a-pdf": {
    h1Title: "Convertir Word a PDF Gratis — DOCX a PDF Profesional",
    seoTitle: "Convertir Word a PDF Gratis Online | Picamini.online",
    seoDescription: "Convertir Word a PDF online gratis. Transforma documentos DOCX y DOC en archivos PDF limpios y listos para enviar.",
    intro: "Pasa tus documentos de Word a formato PDF directamente en tu navegador garantizando que la tipografía y formato se vean igual en cualquier dispositivo.",
  },
  "convertir-excel-a-pdf": {
    h1Title: "Convertir Excel a PDF Gratis — XLSX a PDF",
    seoTitle: "Convertir Excel a PDF Gratis Online | Picamini.online",
    seoDescription: "Convierte hojas de cálculo de Excel en tablas PDF perfectamente maquetadas y listas para imprimir.",
    intro: "Transforma tus tablas de Excel en documentos PDF claros y formateados sin desajustes.",
  },
  "convertir-powerpoint-a-pdf": {
    h1Title: "Convertir PowerPoint a PDF Gratis — PPTX a PDF",
    seoTitle: "Convertir PowerPoint a PDF Gratis Online | Picamini.online",
    seoDescription: "Convierte presentaciones de diapositivas PPTX a documentos PDF compactos.",
    intro: "Pasa tus diapositivas de PowerPoint a PDF para enviarlas o presentarlas cómodamente en cualquier equipo.",
  },
  "convertir-html-a-pdf": {
    h1Title: "Convertir HTML a PDF Gratis — Guardar Código o Web a PDF",
    seoTitle: "Convertir HTML a PDF Gratis Online | Picamini.online",
    seoDescription: "Convierte código HTML o contenido web directamente en tu navegador en un PDF limpio.",
    intro: "Transforma texto o código HTML en un archivo PDF formateado de manera instantánea.",
  },
  "convertir-texto-a-pdf": {
    h1Title: "Convertir Texto (TXT) a PDF Gratis",
    seoTitle: "Convertir Texto a PDF Gratis Online | Picamini.online",
    seoDescription: "Convierte archivos de texto plano (.txt) en documentos PDF limpios con tipografía legible.",
    intro: "Transforma notas y archivos de texto plano en PDF profesionales.",
  },
  "convertir-pdf-a-imagen": {
    h1Title: "Convertir PDF a Imagen Gratis — Extraer JPG o PNG en Alta Calidad",
    seoTitle: "Convertir PDF a Imagen Gratis (PDF a JPG) | Picamini.online",
    seoDescription: "Convertir PDF a JPG o PNG online gratis. Extrae cada página de tu archivo PDF como una imagen en alta resolución de forma instantánea.",
    intro: "Transforma cada página de tu documento PDF en archivos de imagen JPG o PNG de alta resolución listos para usar o guardar en un paquete zip.",
  },
  "convertir-pdf-a-word": {
    h1Title: "Convertir PDF a Word Gratis — PDF a DOCX Editable",
    seoTitle: "Convertir PDF a Word Gratis Online | Picamini.online",
    seoDescription: "Convertir PDF a Word online gratis. Extrae el contenido de tus PDF en documentos editables de Word DOCX conservando el texto.",
    intro: "Transforma tus documentos PDF en archivos editables de Microsoft Word para modificar texto o contenido fácilmente.",
  },
  "convertir-pdf-a-excel": {
    h1Title: "Convertir PDF a Excel Gratis — Extraer Tablas a XLSX",
    seoTitle: "Convertir PDF a Excel Gratis Online | Picamini.online",
    seoDescription: "Extrae tablas de datos contenidas en archivos PDF a hojas de cálculo editables de Excel.",
    intro: "Convierte tablas de PDF en hojas de cálculo de Excel para editar números e informes.",
  },
  "convertir-pdf-a-texto": {
    h1Title: "Extraer Texto de PDF Gratis — Copiar Contenido de PDF",
    seoTitle: "Extraer Texto de PDF Gratis Online | Picamini.online",
    seoDescription: "Extrae el texto plano de tus archivos PDF en un archivo .txt ligero de forma instantánea.",
    intro: "Obtén todo el texto escrito de tus PDF sin formato complejo en un archivo de texto limpio.",
  },
  "proteger-pdf": {
    h1Title: "Proteger PDF con Contraseña Gratis — Encriptar Archivos PDF",
    seoTitle: "Proteger PDF con Contraseña Gratis Online | Picamini.online",
    seoDescription: "Proteger PDF con clave online gratis. Encripta tus documentos confidenciales con seguridad de 128 bits directamente en tu dispositivo.",
    intro: "Protege la privacidad de tus documentos encriptando el archivo con una contraseña de apertura segura que nadie más podrá saltarse.",
  },
  "desbloquear-pdf": {
    h1Title: "Desbloquear PDF Gratis Online — Quitar Contraseña de PDF",
    seoTitle: "Desbloquear PDF Gratis Online — Quitar Contraseña | Picamini.online",
    seoDescription: "Desbloquear PDF online gratis — elimina contraseñas y restricciones de edición en archivos PDF de tu propiedad sin subir datos a internet.",
    intro: "Elimina contraseñas de apertura o restricciones de impresión en archivos PDF de los que seas propietario de manera rápida y segura.",
  },
  "firmar-pdf": {
    h1Title: "Firmar PDF Online Gratis — Firma Digital y Manuscrita",
    seoTitle: "Firmar PDF Online Gratis | Picamini.online",
    seoDescription: "Añade tu firma manuscrita o imagen de sello en contratos y formularios PDF sin imprimir.",
    intro: "Firma documentos PDF dibujando tu firma o subiendo una imagen directamente desde tu navegador.",
  },
  "ocr-pdf": {
    h1Title: "Reconocimiento de Texto OCR en PDF Gratis",
    seoTitle: "OCR en PDF Gratis Online | Picamini.online",
    seoDescription: "Reconocimiento óptico de caracteres (OCR) para hacer buscables y copiables los PDF escaneados.",
    intro: "Convierte documentos PDF escaneados en archivos con texto buscable y seleccionable mediante OCR.",
  }
};

export function getEsPdfToolContent(slug: string, fallbackName: string): ToolContent {
  const tool = getEsPdfToolBySlug(slug);
  const esSlug = tool ? tool.slug : slug;
  const enSlug = tool ? tool.enSlug : slug;

  const override = ES_PDF_SEO_DATA[esSlug] || ES_PDF_SEO_DATA[enSlug] || {};
  const name = fallbackName;

  return {
    seoTitle: override.seoTitle || `${name} Gratis Online | Picamini.online`,
    seoDescription: override.seoDescription || `Herramienta PDF ${name.toLowerCase()} gratis online. Procesa tus archivos 100% privado en tu propio navegador.`,
    h1Title: override.h1Title || `${name} Online Gratis — 100% en tu Navegador`,
    intro: override.intro || `Utiliza nuestra herramienta de ${name.toLowerCase()} de forma rápida, privada y sin límites. Todo el procesamiento ocurre en tu propio equipo.`,
    whatIs: [
      `La herramienta ${name} forma parte de la suite PDF Toolkit Pro de Picamini.online, diseñada para ofrecer un procesamiento de documentos ultrarrápido y seguro.`,
      `A diferencia de otros convertidores en línea que suben tus archivos privados a servidores en la nube, nuestro sistema ejecuta todas las operaciones en la memoria de tu propio dispositivo.`,
      `Esto garantiza una velocidad máxima sin tiempos de espera de subida y con total privacidad de tus datos.`
    ],
    howTo: [
      "Arrastra o selecciona tu archivo PDF en la zona de trabajo.",
      "Ajusta las opciones según tus necesidades (páginas, orden, calidad o contraseña).",
      "Haz clic en el botón principal para procesar el documento en segundos.",
      "Descarga tu archivo PDF resultante inmediatamente a tu dispositivo."
    ],
    features: [
      "100% Gratis sin límites de archivos ni marcas de agua",
      "Privacidad absoluta: Tus documentos nunca salen de tu ordenador",
      "Procesamiento ultrarrápido en el navegador",
      "Compatible con cualquier sistema operativo (Windows, Mac, Linux, Android e iOS)",
      "Sin registros, cuentas ni instalación de programas"
    ],
    benefits: [
      "Cumplimiento total de privacidad al no enviar datos a servidores externos",
      "Disponibilidad inmediata sin colas de procesamiento",
      "Conserva la nitidez y formato de tus archivos originales"
    ],
    proTips: [
      "Para contratos confidenciales o documentos personales, este sistema en navegador es la opción más segura.",
      "Si vas a procesar múltiples archivos, asegúrate de permitir descargas múltiples en tu navegador."
    ],
    faq: override.faq || [
      {
        q: `¿Es seguro usar ${name}?`,
        a: "Sí, totalmente seguro. Al procesarse en tu propio navegador, tus archivos nunca se transmiten por internet."
      },
      {
        q: "¿Tengo que registrarme o pagar alguna tarifa?",
        a: "No. Todas las herramientas de Picamini.online son 100% gratuitas y no requieren ningún tipo de registro."
      }
    ]
  };
}
